import React from 'react'

export const AppState = React.createContext({})
